<template>
    <div>
        <template v-if="!configModalCreateOrEditPrize.model">
            <div class="mb-3">
                <button :disabled="isView" type="button" class="btn btn-info" @click="onHandleOpenCreate">
                    {{ $t('managerForm.settingSerialCode.createNewPrize') }}
                </button>
            </div>
            <div class="table-responsive" style="max-height: 60vh">
                <table class="table table-bordered table-box table-hover table-resize">
                    <thead>
                        <tr>
                            <th
                                v-for="(item, idx) in CONFIG_TABLE_PRIZE_SERIAL_CODE.headers"
                                :key="idx"
                                class="text-left position-sticky"
                                :style="`background-color: #ffff; top: 0; width: ${item.width}px;`"
                            >
                                <div class="el-table__cell">
                                    {{ item.label }}
                                </div>
                            </th>
                            <th :style="{ width: 250 + 'px', top: 0, zIndex: 20 }" :class="`text-center sticky_action`"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(prizeSerial, idx) in listPrizeSerial" :key="idx">
                            <td class="text-left">
                                <div class="el-table__cell">
                                    {{ prizeSerial.title }}
                                </div>
                            </td>
                            <td class="text-left">
                                <div v-if="prizeSerial.image?.path" class="w-100 p-2">
                                    <img
                                        class="w-100 h-100"
                                        style="object-fit: cover; object-position: center"
                                        :src="prizeSerial.image?.path"
                                        :alt="prizeSerial.image?.path"
                                    />
                                </div>
                            </td>
                            <td class="text-left">
                                <div class="el-table__cell"></div>
                                {{ renderTypePrize(prizeSerial.prize_type) }}
                            </td>
                            <td class="text-left">
                                <div class="el-table__cell"></div>
                                {{ prizeSerial.probability_of_winning }}%
                            </td>
                            <td class="text-left">
                                <div class="el-table__cell">
                                    {{
                                        !!prizeSerial.start_time_winning && !!prizeSerial.end_time_winning
                                            ? `${getTimeFormat(prizeSerial.start_time_winning)} - ${getTimeFormat(prizeSerial.end_time_winning)}`
                                            : ''
                                    }}
                                </div>
                            </td>
                            <td class="text-left">
                                <div class="el-table__cell">
                                    {{
                                        prizeSerial.current_probability?.toString()
                                            ? prizeSerial.current_probability
                                            : prizeSerial.probability_of_winning
                                    }}%
                                </div>
                            </td>
                            <td class="text-left">
                                <div class="el-table__cell">
                                    {{ onHandleVisibleNumberInKind(prizeSerial) }}
                                </div>
                            </td>
                            <td class="text-left">
                                <div class="el-table__cell">{{ prizeSerial?.won_count || 0 }}</div>
                            </td>
                            <td class="text-left">
                                <div class="el-table__cell">
                                    {{
                                        prizeSerial?.remaining_count?.toString()
                                            ? prizeSerial?.remaining_count
                                            : onHandleVisibleNumberInKind(prizeSerial)
                                    }}
                                </div>
                            </td>
                            <td class="text-left sticky_action" style="z-index: 14">
                                <button type="button" class="btn btn-primary" @click="onHandleEditPrize(prizeSerial)">
                                    {{ isView ? $t('btn.detail') : $t('btn.edit') }}
                                </button>
                                <button type="button" class="btn btn-secondary ml-2" @click="onHandleSettingCalendar(prizeSerial)">
                                    {{ $t('managerForm.settingSerialCode.calendarsettings') }}
                                </button>
                                <button :disabled="isView" type="button" class="btn btn-info ml-2" @click="onHandleCopyPrize(prizeSerial)">
                                    複製
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
        <!-- create/edit -->
        <template v-else>
            <div class="form-group row mb-3">
                <label class="col-sm-1 text-nowrap" style="min-width: 120px"
                    >{{ $t('managerForm.settingSerialCode.titleSerialCode') }}
                    <span v-if="onHandleCheckFieldRequired(formPrizeSerialConfig.title.typesValidate)" class="text-danger">*</span></label
                >
                <div class="col-sm-10">
                    <InputText
                        :disabled="isView"
                        :model.sync="formPrizeSerialInit.title"
                        :config.sync="formPrizeSerialConfig.title"
                        @blur="handleValidateField(formPrizeSerialInit.title, formPrizeSerialConfig.title)"
                    />
                </div>
            </div>
            <div class="form-group row mb-3">
                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('managerForm.settingSerialCode.imgSerialCode') }}</label>
                <div class="col-sm-10">
                    <UploadImageCommon
                        :disabled="isView"
                        :id="`uploadImgPrize`"
                        class="mb-2"
                        :fileValues.sync="formPrizeSerialInit.image"
                        :config="{ maxSize: 10240 }"
                        @dataFile="handleUpdateImage"
                        @removeFile="handleUpdateImage"
                    >
                    </UploadImageCommon>
                    <p class="note">※10MB以内の画像をアップロード可能です。</p>
                    <div v-if="formPrizeSerialInit.image" class="d-flex flex-wrap">
                        <div class="form-group row mb-3">
                            <label class="col-sm-1 text-nowrap" style="max-width: fit-content"
                                >{{ $t('managerForm.settingSerialCode.widthImage') }}
                                <span v-if="onHandleCheckFieldRequired(formPrizeSerialConfig.width_image.typesValidate)" class="text-danger"
                                    >*</span
                                ></label
                            >
                            <InputText
                                :disabled="isView"
                                class="pr-4"
                                :style-input="{ width: '110px' }"
                                :model.sync="formPrizeSerialInit.width_image"
                                :config.sync="formPrizeSerialConfig.width_image"
                                @blur="handleValidateField(formPrizeSerialInit.width_image, formPrizeSerialConfig.width_image)"
                                @input="handleUpdateWidthImage(formPrizeSerialInit.width_image)"
                            />
                        </div>
                        <div class="form-group row mb-3">
                            <label class="col-sm-1 text-nowrap" style="max-width: fit-content"
                                >{{ $t('managerForm.settingSerialCode.heightImage') }}
                                <span v-if="onHandleCheckFieldRequired(formPrizeSerialConfig.height_image.typesValidate)" class="text-danger"
                                    >*</span
                                ></label
                            >
                            <InputText
                                :disabled="isView"
                                :style-input="{ width: '110px' }"
                                :model.sync="formPrizeSerialInit.height_image"
                                :config.sync="formPrizeSerialConfig.height_image"
                                @input="handleUpdateHeightImage(formPrizeSerialInit.height_image)"
                                @blur="handleValidateField(formPrizeSerialInit.height_image, formPrizeSerialConfig.height_image)"
                            />
                        </div>
                        <div class="col-sm-1 mb-3 mt-2 h-100">
                            <div class="pl-3" :style="{ cursor: isView ? 'default' : 'pointer' }" @click="isView ? null : handleLockRatio()">
                                <i :class="formPrizeSerialInit.extension?.is_lock_ratio ? 'fa fa-lock' : 'fa fa-unlock'"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group row mb-3">
                <label class="col-sm-1 text-nowrap" style="min-width: 120px"
                    >{{ $t('managerForm.settingSerialCode.probabilityofWinning') }}
                    <span v-if="onHandleCheckFieldRequired(formPrizeSerialConfig.probability_of_winning.typesValidate)" class="text-danger">*</span>
                </label>
                <div class="col-sm-10">
                    <div class="d-flex flex-wrap" style="gap: 1rem">
                        <InputText
                            :disabled="isView"
                            class="p-0 col-4"
                            :model.sync="formPrizeSerialInit.probability_of_winning"
                            :config.sync="formPrizeSerialConfig.probability_of_winning"
                            @blur="
                                handleValidateField(
                                    formPrizeSerialInit.probability_of_winning,
                                    formPrizeSerialConfig.probability_of_winning,
                                    'probabilityOfWinning'
                                )
                            "
                        />
                        <div class="mt-2">%</div>
                    </div>
                </div>
            </div>
            <div class="form-group row mb-3">
                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('managerForm.settingSerialCode.typeSerialCode') }}</label>
                <div class="col-sm-10">
                    <div class="d-flex flex-wrap mb-2">
                        <div v-for="item in TYPE_PRIZE" :key="item.id">
                            <InputRadio
                                :disabled="isView"
                                class="mr-3 mb-2"
                                :model.sync="formPrizeSerialInit.prize_type"
                                :id="`raido-prizeType${item.id}`"
                                :name="`radio-prizeType`"
                                :value="item.id"
                                :label="item.name"
                                @change="onHandleChangePrizeType"
                            />
                        </div>
                    </div>
                    <div v-if="formPrizeSerialInit.prize_type === TYPE_PRIZE[0].id" class="form-group row mb-3">
                        <label class="text-nowrap px-3" style="min-width: 30px"
                            >{{ $t('managerForm.settingSerialCode.numberInKind') }}
                            <span v-if="onHandleCheckFieldRequired(formPrizeSerialConfig.number_in_kind.typesValidate)" class="text-danger">*</span>
                        </label>
                        <div class="col-sm-3">
                            <InputText
                                :disabled="isView"
                                :model.sync="formPrizeSerialInit.number_in_kind"
                                :config.sync="formPrizeSerialConfig.number_in_kind"
                                @blur="handleValidateField(formPrizeSerialInit.number_in_kind, formPrizeSerialConfig.number_in_kind)"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="formPrizeSerialInit.prize_type === TYPE_PRIZE[1].id">
                <div class="form-group row" style="border: 1px solid #dee2e6; padding: 1.5rem 1.5rem 1.5rem 0px">
                    <label class="col-sm-1" style="min-width: 120px">賞品コード登録</label>
                    <div class="col-sm-10">
                        <div class="d-flex flex-wrap align-items-center justify-content-between" style="gap: 1rem">
                            <div class="d-flex">
                                <div v-for="item in OPTION_IMPORT_SERIAL_CODE" :key="item.id">
                                    <InputRadio
                                        :disabled="isView"
                                        class="mr-3 mb-2"
                                        :model.sync="import_product"
                                        :id="`raido-import_product${item.id}`"
                                        :name="`radio-import_product`"
                                        :value="item.id"
                                        :label="item.name"
                                    />
                                </div>
                            </div>
                            <button type="button" class="btn btn-secondary" @click="downLoadFileCsvProd('template')">テンプレートダウンロード</button>
                        </div>
                        <div class="mt-2 mb-4">
                            <p class="mb-2">【※注意事項】</p>
                            <ul class="mb-2">
                                <li v-for="(item, idx) in LIST_NOTE_IMPORT_PRODUCT_CODE" :key="`note-import-${idx}`">{{ item.label }}</li>
                            </ul>
                            <p class="mb-0">それ以外の列については、列名が重複しない限り、任意にいくつでも追加可能です。</p>
                        </div>
                        <template>
                            <UploadFileCommon
                                :disabled="isView"
                                :id="`uploadCsvProduct`"
                                class="mb-0"
                                :fileValues.sync="product_file"
                                :config="{
                                    maxSize: 2048,
                                    allowedExtension: ['csv']
                                }"
                                :isImportStyle="true"
                                :typeUpload="'import'"
                                title="インポート"
                                @importFile="
                                    (evt) => {
                                        importedProductFile = evt;
                                        isErrorFile = false;
                                    }
                                "
                            />
                        </template>
                        <div class="d-flex align-items-center mt-4" style="gap: 1rem">
                            <div>
                                <button :disabled="isView || !product_file" type="button" class="btn btn-primary px-4" @click="onHandleImportFile">
                                    {{ $t('btn.register') }}
                                </button>
                            </div>
                            <div v-if="isErrorFile" class="text-danger" style="gap: 1rem">
                                【登録失敗のお知らせ】<br />
                                シリアルコードごとのエラー内容を記載したファイルを返却しています。内容をご確認のうえ、修正後に再度登録してください。
                            </div>
                            <div v-else>
                                {{
                                    import_product === OPTION_IMPORT_SERIAL_CODE[1].id
                                        ? '※登録を実行するたびに新しいシリアルコードが追加されます。'
                                        : '※登録を実行するたびに新しいシリアルコードが上書きされます。'
                                }}
                            </div>
                        </div>
                    </div>
                </div>
                <h4 class="mb-3 font-weight-bold border-bottom pb-2">【登録済み賞品コード一覧】</h4>
                <div class="d-flex align-items-center" style="gap: 10px">
                    <div>総当選数 : {{ tableDataProductImport.length }}</div>
                    <div class="ml-auto">
                        <button
                            :disabled="tableDataProductImport.length === 0"
                            type="button"
                            class="btn btn-secondary"
                            @click="downLoadFileCsvProd()"
                        >
                            データーダウンロード
                        </button>
                    </div>
                </div>
                <div class="table-responsive mt-3">
                    <table class="table table-bordered table-box table-hover table-resize">
                        <template>
                            <colgroup v-if="CONFIG_TABLE_DIGITAL_GIF">
                                <col v-for="(item, colK) in CONFIG_TABLE_DIGITAL_GIF.headers" :key="colK" :style="{ width: item.width + 'px' }" />
                            </colgroup>
                        </template>
                        <thead>
                            <tr>
                                <th
                                    v-for="(item, idx) in CONFIG_TABLE_DIGITAL_GIF.headers"
                                    :key="idx"
                                    class="text-left position-sticky"
                                    :style="`width: ${item.width}px;`"
                                >
                                    <div class="el-table__cell">
                                        {{ item.label }}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, rIdx) in tableDataProductImport" :key="rIdx">
                                <td v-for="(h, hIdx) in CONFIG_TABLE_DIGITAL_GIF.headers" :key="hIdx" class="text-left">
                                    <template v-if="hIdx === 0">
                                        <div class="el-table__cell">
                                            <a v-if="regexUrl(row[h.key])" :href="row[h.key]" target="_blank">{{ row[h.key] }}</a>
                                            <div v-else>{{ row[h.key] }}</div>
                                        </div>
                                    </template>
                                    <div v-else class="el-table__cell">{{ row[h.key] }}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <hr />
            <!-- Block management: Lottery & Rejection -->
            <template>
                <h4 class="mb-3 font-weight-bold border-bottom pb-2">{{ $t('managerForm.settingSerialCode.titleRegisterLotteryAndRejection') }}</h4>
                <div class="form-group row flex-nowrap">
                    <!-- Left panel: block list -->
                    <div class="col-sm-3" style="min-width: 280px">
                        <!-- Lottery blocks -->
                        <div class="mb-3">
                            <p>
                                ※当選結果画面に賞品タイトルを表示する場合は、デフォルトブロック「当選画面の表示」をご利用ください。
                                本ブロックでは、アップロードした画像サイズをそのまま使用し、賞品タイトルは中央揃え・太字で表示される仕様となっています。
                            </p>
                            <h6 class="border-top py-2 font-weight-bold">{{ $t('managerForm.settingSerialCode.bodyLotterySerialCode') }}</h6>
                            <p class="block_property">{{ $t('managerForm.settingPage.addedSettingItems') }}</p>
                            <div v-if="formPrizeSerialInit.prize_type !== TYPE_PRIZE[1].id" class="border-bottom px-3 py-4">
                                <p class="mb-0 p-0 btn text--block" style="font-weight: 500" @click="isView ? null : handleEditButtonLottery()">
                                    {{ $t('managerForm.settingPage.settingButton') }}
                                </p>
                            </div>
                            <div class="d-flex align-items-center p-3" style="gap: 12px">
                                <Multiselect
                                    :id="`select-block-lottery`"
                                    :value.sync="select_block_lottery"
                                    :options="completeListBlock"
                                    :config="configSelectBlockLottery"
                                    :disabled="isView || buttonEvent.eventSettingBlockRejectionSerial"
                                    @remove="handleRemoveBlock"
                                />
                                <button
                                    :disabled="isView || buttonEvent.eventSettingBlockRejectionSerial"
                                    class="btn btn-success btn-sm text-nowrap"
                                    type="button"
                                    @click="handleAddPrizeBlock('is_lottery')"
                                >
                                    {{ $t('btn.addTag') }}
                                </button>
                            </div>
                            <div>
                                <div class="d-flex block_property">
                                    <p class="mb-0">{{ $t('managerForm.settingPage.block') }}</p>
                                    <p class="mb-0 ml-auto pr-1">{{ $t('managerForm.settingPage.choiceBlock') }}</p>
                                </div>
                                <div class="block_list">
                                    <Draggable
                                        :disabled="isView"
                                        v-model="lotteryBlocks"
                                        tag="div"
                                        ghost-class="ghost--option"
                                        @change="onDraggablePrizeChange"
                                    >
                                        <div class="border-bottom px-3 py-4" v-for="(itemBlock, idx) in lotteryBlocks" :key="`lottery-block-${idx}`">
                                            <div class="d-flex">
                                                <p class="mb-0 p-0 btn text--block" @click="isView ? null : handleEditPrizeBlock(itemBlock)">
                                                    <span class="mr-2"
                                                        ><i
                                                            class="mdi mdi-card-text-outline d-inline-flex align-items-center h-100"
                                                            style="font-size: 1rem"
                                                            aria-hidden="true"
                                                    /></span>
                                                    {{ itemBlock.block_name }}
                                                </p>
                                                <InputCheckBox
                                                    v-if="!(buttonEvent.eventSettingBlockRejectionSerial || itemBlock.is_default_display)"
                                                    class="ml-auto"
                                                    :disabled="isView"
                                                    :model.sync="listCheckedPrizeType.is_lottery"
                                                    :id="`check-lottery${idx}`"
                                                    :value="itemBlock"
                                                    :label="``"
                                                    @change="onHandleChangeCheckedBlock('is_lottery')"
                                                />
                                            </div>
                                        </div>
                                    </Draggable>
                                </div>
                                <div class="d-flex justify-content-end mt-2">
                                    <InputCheckBox
                                        v-if="lotteryBlocks.length > 0"
                                        :model.sync="checkAllLottery"
                                        :id="`checkAllLottery`"
                                        :value="checkAllLottery"
                                        :label="`全選択`"
                                        :disabled="isView || buttonEvent.eventSettingBlockRejectionSerial"
                                        @change="onHandleCheckAllLottery"
                                    />
                                </div>
                                <div v-if="lotteryBlocks.length > 0" class="d-flex justify-content-center mt-3" style="gap: 18px">
                                    <button
                                        :disabled="
                                            isView || listCheckedPrizeType.is_lottery.length === 0 || buttonEvent.eventSettingBlockRejectionSerial
                                        "
                                        type="button"
                                        class="alldelete"
                                        @click="handleDeletePrizeBlock('is_lottery')"
                                    >
                                        {{ $t('btn.delete') }}
                                    </button>
                                    <button
                                        :disabled="
                                            isView || listCheckedPrizeType.is_lottery.length === 0 || buttonEvent.eventSettingBlockRejectionSerial
                                        "
                                        type="button"
                                        class="green02_copy"
                                        @click="handleCopyPrizeBlock('is_lottery')"
                                    >
                                        {{ $t('btn.copy') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Right panel: Iframe previews (winning + rejection) -->
                    <div class="col-sm-9" style="gap: 12px">
                        <div
                            v-if="!buttonEvent.eventSettingBlockLotterySerial && !isSettingButtonLottery"
                            class="flex-fill ifame_page overflow-auto border rounded"
                            style="min-height: 400px"
                        >
                            <div class="text-center font-weight-bold p-2 border-bottom bg-light">当選ページ</div>
                            <IframComponent
                                v-if="inforForm"
                                class="mx-auto"
                                :typeHandle="`edit`"
                                typePage="prize_serial"
                                style="width: 100%"
                                :dataForm="prizeIframeDataLottery"
                            />
                        </div>
                        <SettingBlockForm
                            v-if="buttonEvent.eventSettingBlockLotterySerial && configSettingPrizeBlock"
                            ref="settingPrizeBlockForm"
                            :config="configSettingPrizeBlock"
                            :formBlock.sync="initPrizeFormBlock"
                            :configFormInput="configFormInputPrize"
                            :actionTimeAddBlock="actionTimePrizeAddBlock"
                            :listTypeInput="[]"
                            :bgrDefault="bgrDefaultPrize"
                            :inforSettingDesign="inforForm.setting_designs"
                            :idPrefix="`prize_Lottery`"
                            @showSave="handleShowSavePrizeBlock"
                            @cancel="handleCancelPrizeBlock"
                        />
                        <div v-if="isSettingButtonLottery" class="flex-fill overflow-auto border rounded p-4 bg-white">
                            <h5 class="mb-4 font-weight-bold">{{ $t('managerForm.settingPage.settingButton') }}</h5>
                            <div class="form-group row">
                                <label class="col-sm-2 text-nowrap" style="">{{ $t('managerForm.settingPage.buttonRegister') }}</label>
                                <div class="col-sm-10">
                                    <div class="form-group row" style="border-bottom: #d8d8d8 1px solid; padding-bottom: 20px">
                                        <label class="col-sm-2 text-nowrap" style="">{{ $t('managerForm.settingPage.labelButton') }}</label>
                                        <div class="col-sm-10">
                                            <InputText
                                                :model.sync="settingButtonLottery.label_btn_register"
                                                :config.sync="configFormInputPrize.configFieldButtonInput"
                                                @blur="handleValidateFieldPrize(configFormInputPrize.configFieldButtonInput)"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group row mt-3">
                                        <label class="col-sm-2 text-nowrap" style="">{{ $t('managerForm.settingPage.imageButton') }}</label>
                                        <div class="col-sm-10">
                                            <UploadImageCommon
                                                :fileValues.sync="settingButtonLottery.img_btn_register"
                                                :id="`ImageConfirmPrize`"
                                                :config="{
                                                    maxSize: 1024
                                                }"
                                            >
                                                <template #warning>
                                                    <div style="font-size: 13px">
                                                        {{ $t('managerForm.settingPage.noteImageButtonBeautiful') }}
                                                    </div>
                                                </template>
                                            </UploadImageCommon>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="fbtnarea fbtnarea_block my-5">
                                <div class="fbtnarea text-center">
                                    <button type="button" @click="handleCancelSettingBtnLottery" class="btn btn-common-cancel mr-3">
                                        {{ $t('btn.cancel') }}
                                    </button>
                                    <button type="button" @click="handleSaveSettingBtnLottery" class="text-nowrap save__button--setting">
                                        {{ $t('managerForm.settingPage.saveErrorMsg') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <hr />
            <div class="form-group row flex-nowrap">
                <!-- Left panel: block list -->
                <div class="col-sm-3" style="min-width: 280px">
                    <!-- Rejection blocks -->
                    <div>
                        <h6 class="border-top py-2 font-weight-bold">{{ $t('managerForm.settingSerialCode.bodyRejectionSerialCode') }}</h6>
                        <p class="block_property">{{ $t('managerForm.settingPage.addedSettingItems') }}</p>
                        <div class="d-flex align-items-center p-3" style="gap: 12px">
                            <Multiselect
                                :id="`select-block-rejection`"
                                :value.sync="select_block_rejection"
                                :options="completeListBlock"
                                :config="configSelectBlockRejection"
                                :disabled="isView || buttonEvent.eventSettingBlockLotterySerial || !inforLottery.is_prize_before_the_draw"
                                @remove="handleRemoveBlock"
                            />
                            <button
                                :disabled="isView || buttonEvent.eventSettingBlockLotterySerial || !inforLottery.is_prize_before_the_draw"
                                class="btn btn-success btn-sm text-nowrap"
                                type="button"
                                @click="handleAddPrizeBlock('is_rejection')"
                            >
                                {{ $t('btn.addTag') }}
                            </button>
                        </div>
                        <div>
                            <div class="d-flex block_property">
                                <p class="mb-0">{{ $t('managerForm.settingPage.block') }}</p>
                                <p class="mb-0 ml-auto pr-1">{{ $t('managerForm.settingPage.choiceBlock') }}</p>
                            </div>
                            <div class="block_list">
                                <Draggable
                                    :disabled="isView"
                                    v-model="rejectionBlocks"
                                    tag="div"
                                    ghost-class="ghost--option"
                                    @change="onDraggablePrizeChange"
                                >
                                    <div class="border-bottom px-3 py-4" v-for="(itemBlock, idx) in rejectionBlocks" :key="`rejection-block-${idx}`">
                                        <div class="d-flex">
                                            <p class="mb-0 p-0 btn text--block" @click="isView ? null : handleEditPrizeBlock(itemBlock)">
                                                <span class="mr-2"
                                                    ><i
                                                        class="mdi mdi-card-text-outline d-inline-flex align-items-center h-100"
                                                        style="font-size: 1rem"
                                                        aria-hidden="true"
                                                /></span>
                                                {{ itemBlock.block_name }}
                                            </p>
                                            <InputCheckBox
                                                class="ml-auto"
                                                :model.sync="listCheckedPrizeType.is_rejection"
                                                :id="`check-rejection${idx}`"
                                                :value="itemBlock"
                                                :label="``"
                                                :disabled="
                                                    isView || buttonEvent.eventSettingBlockLotterySerial || !inforLottery.is_prize_before_the_draw
                                                "
                                                @change="onHandleChangeCheckedBlock('is_rejection')"
                                            />
                                        </div>
                                    </div>
                                </Draggable>
                            </div>
                            <div class="d-flex justify-content-end mt-2">
                                <InputCheckBox
                                    v-if="rejectionBlocks.length > 0"
                                    :model.sync="checkAllRejection"
                                    :id="`checkAllRejection`"
                                    :value="checkAllRejection"
                                    :label="`全選択`"
                                    @change="onHandleCheckAllRejection"
                                    :disabled="isView || buttonEvent.eventSettingBlockLotterySerial || !inforLottery.is_prize_before_the_draw"
                                />
                            </div>
                            <div v-if="rejectionBlocks.length > 0" class="d-flex justify-content-center mt-3" style="gap: 18px">
                                <button
                                    :disabled="
                                        isView ||
                                        listCheckedPrizeType.is_rejection.length === 0 ||
                                        buttonEvent.eventSettingBlockLotterySerial ||
                                        !inforLottery.is_prize_before_the_draw
                                    "
                                    type="button"
                                    class="alldelete"
                                    @click="handleDeletePrizeBlock('is_rejection')"
                                >
                                    {{ $t('btn.delete') }}
                                </button>
                                <button
                                    :disabled="
                                        isView ||
                                        listCheckedPrizeType.is_rejection.length === 0 ||
                                        buttonEvent.eventSettingBlockLotterySerial ||
                                        !inforLottery.is_prize_before_the_draw
                                    "
                                    type="button"
                                    class="green02_copy"
                                    @click="handleCopyPrizeBlock('is_rejection')"
                                >
                                    {{ $t('btn.copy') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Right panel: Iframe previews (winning + rejection) -->
                <div class="col-sm-9" style="gap: 12px">
                    <div
                        v-if="!buttonEvent.eventSettingBlockRejectionSerial"
                        class="flex-fill ifame_page overflow-auto border rounded"
                        style="min-height: 400px"
                    >
                        <div class="text-center font-weight-bold p-2 border-bottom bg-light">落選ページ</div>
                        <IframComponent
                            v-if="inforForm"
                            class="mx-auto"
                            :typeHandle="`edit`"
                            typePage="prize_serial"
                            style="width: 100%"
                            :dataForm="prizeIframeDataRejection"
                        />
                    </div>
                    <SettingBlockForm
                        v-if="buttonEvent.eventSettingBlockRejectionSerial && configSettingPrizeBlock"
                        ref="settingPrizeBlockForm"
                        :config="configSettingPrizeBlock"
                        :formBlock.sync="initPrizeFormBlock"
                        :configFormInput="configFormInputPrize"
                        :actionTimeAddBlock="actionTimePrizeAddBlock"
                        :listTypeInput="[]"
                        :bgrDefault="bgrDefaultPrize"
                        :inforSettingDesign="inforForm.setting_designs"
                        :idPrefix="`prize_rejection`"
                        @showSave="handleShowSavePrizeBlock"
                        @cancel="handleCancelPrizeBlock"
                    />
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import moment from 'moment';
import UploadFileCommon from '@/components/Uploads/Files/main.vue';
import UploadImageCommon from '@/components/Uploads/Image/main.vue';
import Draggable from 'vuedraggable';
import Multiselect from '@/components/Multiselect/main.vue';
import SettingBlockForm from '../setting-block-form/main.vue';
import IframComponent from '../../iframe-page/main.vue';

import { mapState } from 'vuex';
import { managerFormMethods } from '@/state/helpers';
import { InputRadio, InputText, InputCheckBox } from '@/components/Input';
import { BLOCK_COMMON, ALL_BLOCK_TYPE } from '@/config/constants';
import { initFormBlock, configEditFormPage } from '../setting-page/constants';
import { configFormInput, BGR_DEFAULT } from '../setting-block-form/constants';
import { PAGE_TYPES } from '../../constants';
import {
    TYPE_PRIZE,
    CONFIG_TABLE_PRIZE_SERIAL_CODE,
    CONFIG_TABLE_DIGITAL_GIF,
    configModalCreateOrEditPrize,
    initFormPrizeSerial,
    configFormPrizeSerial,
    buildHeaders,
    mapTableData,
    unflattenItem,
    // processBodyLottery,
    onHandleMapColumnIndex,
    validateMaxDecimals,
    LIST_NOTE_IMPORT_PRODUCT_CODE,
    getMaxColumnIndex,
    getLabels
} from '@/views/pages/phase2/manager-form/components/prize-serial-code/constants';
import { OPTION_IMPORT_SERIAL_CODE } from '@/views/pages/phase2/manager-form/components/setting-serial-code/constants';
import { validateField, validateAllField } from '@/utils/validate_v2';
import { onHandleCheckFieldRequired } from '@/utils/handlers';
import { onHandleFakeId, onScrollToFieldError } from '@/utils/handlers';
import { showMessage } from '@/utils/messages';
import { handleDownFile, getTimeFormat, generateUniqueBlockName } from '@/utils/format';
import { onHandleSumDailyLimitPrize } from '@/views/pages/phase2/manager-form/components/setting-calendar/constants';
import { regexUrl } from '@/utils/regex';

export default {
    name: 'PrizeSerialCode',
    components: {
        UploadFileCommon,
        UploadImageCommon,
        InputRadio,
        InputText,
        InputCheckBox,
        Draggable,
        Multiselect,
        SettingBlockForm,
        IframComponent
    },
    props: {
        dataPrizes: {
            type: Array,
            default: () => []
        },
        inforForm: {
            type: Object,
            default: () => {}
        },
        inforLottery: {
            type: Object,
            default: () => ({})
        },
        isView: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            LIST_NOTE_IMPORT_PRODUCT_CODE,
            PAGE_TYPES,
            CONFIG_TABLE_PRIZE_SERIAL_CODE,
            CONFIG_TABLE_DIGITAL_GIF: CONFIG_TABLE_DIGITAL_GIF(),
            TYPE_PRIZE,
            OPTION_IMPORT_SERIAL_CODE,
            configModalCreateOrEditPrize: configModalCreateOrEditPrize(),
            formPrizeSerialInit: initFormPrizeSerial(),
            formPrizeSerialConfig: configFormPrizeSerial(),
            listPrizeSerial: this.dataPrizes,
            import_product: OPTION_IMPORT_SERIAL_CODE[0].id,
            isLoadingDown: false,
            headerIndex: 2,
            originProductImport: [],
            tableDataProductImport: [],
            product_file: null,
            importedProductFile: null,
            isLoadingImport: false,
            isErrorFile: false,
            // Block management
            completeListBlock: BLOCK_COMMON.filter((b) => b.type === ALL_BLOCK_TYPE.BLOCK_DISPLAY_1),
            select_block_lottery: null,
            select_block_rejection: null,
            configSelectBlockLottery: configEditFormPage().configFieldSelectBlock,
            configSelectBlockRejection: configEditFormPage().configFieldSelectBlock,
            listCheckedPrizeType: {
                is_lottery: [],
                is_rejection: []
            },
            checkAllLottery: false,
            checkAllRejection: false,
            configSettingPrizeBlock: null,
            initPrizeFormBlock: initFormBlock(),
            configFormInputPrize: configFormInput(),
            actionTimePrizeAddBlock: 0,
            bgrDefaultPrize: BGR_DEFAULT(null),
            prizePreviewPage: PAGE_TYPES._B[2],
            recordInProcessEdit: null,
            isSettingButtonLottery: false,
            isInitialPrizeData: false,
            settingButtonLottery: {
                label_btn_register: '',
                img_btn_register: null
            }
        };
    },
    computed: {
        ...mapState({
            ...mapState('managerForm', ['buttonEvent'])
        }),

        sumDailyLimitPrize() {
            return onHandleSumDailyLimitPrize(this.listPrizeSerial, this.formPrizeSerialInit);
        },
        lotteryBlocks: {
            get() {
                return (this.formPrizeSerialInit.blocks || []).filter((b) => b.is_lottery);
            },
            set(val) {
                // merge sorted lottery blocks back with rejection blocks
                const rejection = (this.formPrizeSerialInit.blocks || []).filter((b) => !b.is_lottery);
                this.formPrizeSerialInit.blocks = [...val, ...rejection];
            }
        },
        rejectionBlocks: {
            get() {
                return (this.formPrizeSerialInit.blocks || []).filter((b) => b.is_rejection);
            },
            set(val) {
                const lottery = (this.formPrizeSerialInit.blocks || []).filter((b) => b.is_lottery);
                this.formPrizeSerialInit.blocks = [...lottery, ...val];
            }
        },
        prizeIframeDataLottery() {
            if (!this.inforForm) return null;
            return {
                ...this.inforForm,
                prize_blocks: this.lotteryBlocks,
                setting_buttons: this.formPrizeSerialInit.prize_type === TYPE_PRIZE[1].id ? null : this.formPrizeSerialInit.setting_buttons
            };
        },
        prizeIframeDataRejection() {
            if (!this.inforForm) return null;
            return {
                ...this.inforForm,
                prize_blocks: this.rejectionBlocks
            };
        }
    },
    methods: {
        ...managerFormMethods,
        onHandleCheckFieldRequired,
        getTimeFormat,
        regexUrl,

        // ─── Block management methods ───────────────────────────────────────
        handleAddPrizeBlock(extensionKey) {
            let selectRef = extensionKey === 'is_lottery' ? this.select_block_lottery : this.select_block_rejection;
            if (!selectRef?.id) return;
            this.actionTimePrizeAddBlock = Math.random();
            this.configSettingPrizeBlock = {
                ...selectRef,
                block_name: selectRef.name,
                typeScreen: 'prize_serial'
            };
            this.initPrizeFormBlock = initFormBlock();
            this.initPrizeFormBlock.id = onHandleFakeId(this.formPrizeSerialInit.blocks || []);
            this.initPrizeFormBlock.block_type = selectRef.type;
            this.initPrizeFormBlock._pendingExtensionKey = extensionKey;
            this.configFormInputPrize = configFormInput();
            switch (extensionKey) {
                case 'is_lottery':
                    this.updateButtonEvent({ eventSettingBlockLotterySerial: true });
                    this.onHandleStrBodyLottery({ isAddBlock: true });
                    break;
                case 'is_rejection':
                    this.updateButtonEvent({ eventSettingBlockRejectionSerial: true });
                    break;
            }
            this.initPrizeFormBlock.is_scroll_none = true;
            this.isSettingButtonLottery = false;
        },

        handleEditButtonLottery() {
            if (this.buttonEvent.eventSettingBlockRejectionSerial) return;
            this.isSettingButtonLottery = true;
            this.updateButtonEvent({ eventSettingBlockLotterySerial: false, eventSettingBlockRejectionSerial: false });
            this.settingButtonLottery = JSON.parse(JSON.stringify(this.formPrizeSerialInit.setting_buttons));
        },

        handleSaveSettingBtnLottery() {
            const configValidation = this.configFormInputPrize.configFieldButtonInput;
            this.handleValidateFieldPrize(configValidation);
            if (configValidation.error) {
                showMessage(422, this.$bvToast, this.$t('managerForm.settingPage.errorValidateButton'));
                return;
            }
            this.formPrizeSerialInit.setting_buttons = JSON.parse(JSON.stringify(this.settingButtonLottery));
            this.isSettingButtonLottery = false;
        },

        handleCancelSettingBtnLottery() {
            this.isSettingButtonLottery = false;
            this.settingButtonLottery = {
                label_btn_register: '',
                img_btn_register: null
            };
        },

        handleValidateFieldPrize(config) {
            config.error = false;
            const value = this.settingButtonLottery[config.valueSync || 'label_btn_register'];
            if (config.typesValidate.includes('required') && !value) {
                config.error = true;
                config.errorCustomMess = this.$t('managerForm.settingPage.errorRequired');
                return;
            }
            if (config.typesValidate.includes('maxCustom') && value?.length > config.length) {
                config.error = true;
                config.errorCustomMess = this.$t('managerForm.settingPage.errorMaxCustom', { length: config.length });
                return;
            }
        },

        handleEditPrizeBlock(itemBlock) {
            if (!itemBlock) return;
            if (itemBlock.is_lottery && this.buttonEvent.eventSettingBlockRejectionSerial) return;
            if (itemBlock.is_rejection && (this.buttonEvent.eventSettingBlockLotterySerial || !this.inforLottery.is_prize_before_the_draw)) return;
            const blockTemplate = BLOCK_COMMON.find((b) => b.type === itemBlock.block_type);
            this.actionTimePrizeAddBlock = Math.random();
            this.configSettingPrizeBlock = {
                ...blockTemplate,
                block_name: blockTemplate?.name || itemBlock.block_name,
                typeScreen: 'prize_serial'
            };
            this.initPrizeFormBlock = initFormBlock(itemBlock);
            this.initPrizeFormBlock._pendingExtensionKey = itemBlock.is_lottery ? 'is_lottery' : 'is_rejection';
            this.configFormInputPrize = configFormInput();
            switch (this.initPrizeFormBlock._pendingExtensionKey) {
                case 'is_lottery':
                    this.recordInProcessEdit = {
                        isEditBlock: true,
                        idBlock: itemBlock.id,
                        contentBodyLottery: itemBlock.label,
                        isNeedUpdate: itemBlock.is_need_update
                    };
                    this.updateButtonEvent({ eventSettingBlockLotterySerial: true });
                    this.onHandleStrBodyLottery(this.recordInProcessEdit);
                    break;
                case 'is_rejection':
                    this.updateButtonEvent({ eventSettingBlockRejectionSerial: true });
                    break;
            }
            this.isSettingButtonLottery = false;
        },

        handleShowSavePrizeBlock(savedBlock) {
            if (!savedBlock) return;
            const blocks = this.formPrizeSerialInit.blocks ? [...this.formPrizeSerialInit.blocks] : [];
            const existingBlock = blocks.find(
                (b) => (savedBlock.id != null && b?.id === savedBlock.id) || (savedBlock.make_id != null && b?.make_id === savedBlock.make_id)
            );
            const extensionKey = savedBlock._pendingExtensionKey || this.initPrizeFormBlock._pendingExtensionKey;
            const blockWithExt = {
                ...savedBlock,
                is_lottery: extensionKey === 'is_lottery',
                is_rejection: extensionKey === 'is_rejection',
                is_need_update: false
            };
            delete blockWithExt._pendingExtensionKey;
            if (blockWithExt.extension) {
                delete blockWithExt.extension.is_lottery;
                delete blockWithExt.extension.is_rejection;
            }
            if (existingBlock) {
                Object.assign(existingBlock, blockWithExt);
            } else {
                blocks.push(blockWithExt);
            }
            this.formPrizeSerialInit.blocks = blocks;
            this.updateButtonEvent({ eventSettingBlockLotterySerial: false, eventSettingBlockRejectionSerial: false });
        },

        onHandleSavePrizeBlock() {
            // Clear all errors first
            Object.keys(this.configFormInputPrize).forEach((key) => {
                if (this.configFormInputPrize[key] && typeof this.configFormInputPrize[key] === 'object') {
                    this.configFormInputPrize[key].error = false;
                }
            });
            let isValid = true;

            // 1. Validate Block Name (Always required)
            isValid = validateField(this.initPrizeFormBlock.block_name, this.configFormInputPrize.configFieldNameBlock) && isValid;

            // 2. Validate Fields based on type
            // Content (Label)
            isValid = validateField(this.initPrizeFormBlock.label, this.configFormInputPrize.configFieldLabelBlock) && isValid;

            // Custom Height (if scroll is active)
            if (!this.initPrizeFormBlock.is_scroll_none) {
                isValid = validateField(this.initPrizeFormBlock.custom_height, this.configFormInputPrize.configFieldCustomHeight) && isValid;
            }

            if (!isValid) {
                this.$nextTick(() => {
                    onScrollToFieldError();
                });
                return;
            }
            this.handleShowSavePrizeBlock(this.initPrizeFormBlock);
            this.select_block_lottery = null;
            this.select_block_rejection = null;
        },

        handleCancelPrizeBlock() {
            this.updateButtonEvent({ eventSettingBlockLotterySerial: false, eventSettingBlockRejectionSerial: false });
        },

        handleDeletePrizeBlock(type) {
            if (type === 'is_lottery') {
                this.formPrizeSerialInit.blocks = (this.formPrizeSerialInit.blocks || []).filter(
                    (b) => !this.listCheckedPrizeType.is_lottery.includes(b) || (b.is_default_display && b.is_lottery)
                );
                this.listCheckedPrizeType.is_lottery = [];
            } else {
                this.formPrizeSerialInit.blocks = (this.formPrizeSerialInit.blocks || []).filter(
                    (b) => !this.listCheckedPrizeType.is_rejection.includes(b)
                );
                this.listCheckedPrizeType.is_rejection = [];
            }
            this.checkAllLottery = false;
            this.checkAllRejection = false;
        },

        handleCopyPrizeBlock(extensionKey) {
            let listCopy = [];
            if (extensionKey === 'is_lottery') {
                if (this.listCheckedPrizeType.is_lottery.length === 0) return;
                listCopy = this.listCheckedPrizeType.is_lottery;
            } else {
                if (this.listCheckedPrizeType.is_rejection.length === 0) return;
                listCopy = this.listCheckedPrizeType.is_rejection;
            }
            const copies = listCopy.map((b) => ({ ...b, id: null }));
            copies.forEach((copyItem, index) => {
                delete copyItem.id;
                copyItem.make_id = onHandleFakeId([...(this.formPrizeSerialInit.blocks || []), ...copies.slice(0, index)]);
                copyItem.block_name = `${copyItem.block_name} Copy ${moment().format('YYYY-MM-DD')} ${moment().format('HH:mm')}`;
                copyItem.block_name = generateUniqueBlockName(this.formPrizeSerialInit.blocks, copyItem.block_name);
            });
            this.formPrizeSerialInit.blocks = [...(this.formPrizeSerialInit.blocks || []), ...copies];
            switch (extensionKey) {
                case 'is_lottery':
                    this.checkAllLottery = false;
                    this.listCheckedPrizeType.is_lottery = [];
                    break;
                case 'is_rejection':
                    this.checkAllRejection = false;
                    this.listCheckedPrizeType.is_rejection = [];
                    break;
            }
        },

        onDraggablePrizeChange() {
            // blocks setter already updates formPrizeSerialInit.blocks via computed setters
        },

        onHandleCheckAllLottery(val) {
            if (val) {
                this.listCheckedPrizeType.is_lottery = this.lotteryBlocks.filter((b) => !b.is_default_display);
            } else {
                this.listCheckedPrizeType.is_lottery = this.listCheckedPrizeType.is_lottery.filter((b) => !b.is_lottery);
            }
        },

        onHandleCheckAllRejection(val) {
            if (val) {
                this.listCheckedPrizeType.is_rejection = [...this.rejectionBlocks];
            } else {
                this.listCheckedPrizeType.is_rejection = this.listCheckedPrizeType.is_rejection.filter((b) => !b.is_rejection);
            }
        },
        // ─── End block management ───────────────────────────────────────────
        handleValidateField(valueField, configField, typeValid = null) {
            validateField(valueField, configField);
            if (typeValid === 'probabilityOfWinning') {
                this.onHanleValidDecimal(valueField, configField);
            }
        },

        onHanleValidSumLimit(valueField) {
            let isValid = true;
            if (!valueField) return isValid;
            if (Number(valueField) < this.sumDailyLimitPrize) {
                showMessage(400, this.$bvToast, '個数は、すでに指定されている総数より小さくすることはできません。');
                isValid = false;
            }
            return isValid;
        },

        onHanleValidDecimal(valueField, configField) {
            let isValid = true;
            if (!validateMaxDecimals(valueField) && !!valueField) {
                configField.error = true;
                configField.errorCustomMess = this.$t('validateField.limitInput', {
                    field: configField.errorField,
                    min: configField?.min,
                    max: configField?.max
                });
                isValid = false;
            }
            return isValid;
        },

        onHandleOpenCreate() {
            this.isInitialPrizeData = true;
            this.formPrizeSerialInit = initFormPrizeSerial();
            this.formPrizeSerialConfig = configFormPrizeSerial();
            this.configModalCreateOrEditPrize.title = this.$t('managerForm.settingSerialCode.createNewPrize');
            this.configModalCreateOrEditPrize.titleBtnSave = this.$t('btn.register');
            this.configModalCreateOrEditPrize.model = true;
            this.formPrizeSerialInit.blocks = [];
            this.tableDataProductImport = [];
            this.originProductImport = [];
            this.product_file = null;
            this.importedProductFile = null;
            this.listCheckedPrizeType = {
                is_lottery: [],
                is_rejection: []
            };
            this.checkAllLottery = false;
            this.checkAllRejection = false;
            this.bgrDefaultPrize = BGR_DEFAULT(this.inforForm.setting_designs.table_settings.cell_background_color);
            this.updateButtonEvent({ eventEditPrizeSerialCode: true });
            this.isSettingButtonLottery = false;

            // Add default block
            const defaultBlock = initFormBlock();
            defaultBlock.id = onHandleFakeId([]);
            defaultBlock.block_name = '当選画面の表示';
            defaultBlock.is_default_display = true;
            defaultBlock.is_lottery = true;
            defaultBlock.is_rejection = false;
            defaultBlock.is_scroll_none = true;
            defaultBlock.is_border_display = false;
            defaultBlock.block_type = ALL_BLOCK_TYPE.BLOCK_DISPLAY_1;
            defaultBlock.label = this.onHandleGenerateDefaultLabel();
            this.formPrizeSerialInit.blocks = [defaultBlock];

            this.$nextTick(() => {
                this.isInitialPrizeData = false;
            });
        },

        onHandleCancel() {
            this.configModalCreateOrEditPrize.model = false;
            this.isErrorFile = false;
            this.isSettingButtonLottery = false;
            this.listCheckedPrizeType = {
                is_lottery: [],
                is_rejection: []
            };
            this.checkAllLottery = false;
            this.checkAllRejection = false;
            this.updateButtonEvent({ eventEditPrizeSerialCode: false });
            this.select_block_lottery = null;
            this.select_block_rejection = null;
        },

        handleSave() {
            let isValid = validateAllField(this.formPrizeSerialInit, this.formPrizeSerialConfig);
            isValid =
                this.onHanleValidDecimal(this.formPrizeSerialInit.probability_of_winning, this.formPrizeSerialConfig.probability_of_winning) &&
                this.onHanleValidSumLimit(this.formPrizeSerialInit.number_in_kind) &&
                isValid;
            if (!isValid) {
                this.$nextTick(() => {
                    onScrollToFieldError();
                });
                return;
            }
            if (this.tableDataProductImport?.length > 0) {
                this.formPrizeSerialInit.list_product_import = this.tableDataProductImport.map((item) => unflattenItem(item));
            }
            if (!this.formPrizeSerialInit?.make_id) {
                this.listPrizeSerial.push({
                    make_id: onHandleFakeId(this.listPrizeSerial),
                    ...this.formPrizeSerialInit,
                    start_time_winning: this.inforLottery?.start_time_winning ?? null,
                    end_time_winning: this.inforLottery?.end_time_winning ?? null
                });
            } else {
                const indexEdited = this.listPrizeSerial.findIndex((item) => item.make_id === this.formPrizeSerialInit.make_id);
                if (indexEdited !== -1) {
                    this.listPrizeSerial.splice(indexEdited, 1, {
                        id: this.listPrizeSerial[indexEdited]?.id,
                        ...this.formPrizeSerialInit
                    });
                }
            }
            this.configModalCreateOrEditPrize.model = false;
            this.isErrorFile = false;
            this.updateButtonEvent({ eventEditPrizeSerialCode: false });
            this.select_block_lottery = null;
            this.select_block_rejection = null;
        },

        async onHandleImportFile() {
            if (this.isLoadingImport || !this.importedProductFile) return;
            this.isLoadingImport = true;
            const formData = new FormData();
            formData.append('file', this.importedProductFile);
            if (this.formPrizeSerialInit?.id) {
                formData.append('prize_id', Number(this.formPrizeSerialInit.id));
            }
            if (this.import_product === OPTION_IMPORT_SERIAL_CODE[1].id) {
                const maxIndex = getMaxColumnIndex(this.formPrizeSerialInit.list_product_import);
                const listLabel = getLabels(this.CONFIG_TABLE_DIGITAL_GIF.headers);

                formData.append('column_index_max', maxIndex);
                formData.append('contents', JSON.stringify(listLabel));
            }
            formData.append('type', this.import_product);
            let payload = {
                formId: this.inforForm.id,
                formData
            };
            try {
                const dataImport = await this.importProductForPrize(payload);
                if (!dataImport?.status) {
                    this.product_file = null;
                    this.importedProductFile = null;
                    if (dataImport?.error_file_url) {
                        this.isErrorFile = true;
                        showMessage(400, this.$bvToast, 'ファイル内のエラーを修正して、再度インポートしてください。');
                        handleDownFile(dataImport?.error_file_url, dataImport?.error_file_name || `error-product ${Date.now()}`);
                    }
                    if (dataImport.errors?.length > 0) {
                        dataImport.errors.forEach((item) => {
                            showMessage(400, this.$bvToast, this.$t(item));
                        });
                    }
                } else {
                    const isExitsLottery = this.formPrizeSerialInit.blocks?.some((b) => b.is_lottery && !b.is_default_display);
                    if (isExitsLottery) {
                        showMessage(8080, this.$bvToast, '賞品コードを再インポートされたため、当選文言を更新してください。');
                        this.formPrizeSerialInit.blocks?.forEach((b) => {
                            if (b.is_lottery) b.is_need_update = true;
                        });
                    }
                    showMessage(200, this.$bvToast, 'インポートが正常に完了しました。');
                    this.handleImport(dataImport.data || [], this.import_product === OPTION_IMPORT_SERIAL_CODE[0].id ? 'overwrite' : 'add');
                    this.onHandleStrBodyLottery(
                        !this.recordInProcessEdit
                            ? { isAddBlock: true }
                            : {
                                  ...this.recordInProcessEdit,
                                  isNeedUpdate: true
                              }
                    );
                    this.import_product = OPTION_IMPORT_SERIAL_CODE[0].id;
                    this.product_file = null;
                    this.importedProductFile = null;
                    this.isErrorFile = false;
                }
            } catch (error) {
                showMessage(200, this.$bvToast, error.message);
                this.product_file = null;
                this.importedProductFile = null;
            } finally {
                this.isLoadingImport = false;
            }
        },

        handleImport(importData, mode = 'add') {
            if (mode === 'overwrite') {
                this.originProductImport = JSON.parse(JSON.stringify(importData));
                this.rebuildTable();
                return;
            }
            const map = new Map(this.originProductImport.map((item) => [item.code, item]));
            importData.forEach((item) => {
                const exist = map.get(item.code);
                if (!exist) {
                    map.set(item.code, item);
                    return;
                }
            });
            this.originProductImport = Array.from(map.values());
            this.rebuildTable();
        },
        rebuildTable() {
            this.CONFIG_TABLE_DIGITAL_GIF.headers = buildHeaders(this.originProductImport);
            this.tableDataProductImport = mapTableData(this.originProductImport);
        },

        onHandleStrBodyLottery(objParam = {}) {
            let getColumnIndexContent = [];
            if (TYPE_PRIZE[1].id === this.formPrizeSerialInit.prize_type) {
                const listColumnImport = buildHeaders(this.originProductImport);
                const checkValidKeys = listColumnImport.every((item) => ['code', 'done'].includes(item.key));
                if (!checkValidKeys || this.originProductImport.length > 0) {
                    getColumnIndexContent = onHandleMapColumnIndex(listColumnImport);
                }
            }
            const strImport = getColumnIndexContent.map((item) => `{$${item}}`).join('</br>');
            let bodyValue = '';
            const shouldUpdate = objParam.isAddBlock || objParam.isNeedUpdate;
            if (shouldUpdate) {
                bodyValue = strImport
                    ? `<div>${strImport}</div>`
                    : this.formPrizeSerialInit.prize_type === TYPE_PRIZE[1].id
                      ? '{$*}'
                      : objParam?.contentBodyLottery || '';
            } else {
                bodyValue = objParam?.contentBodyLottery || '';
            }
            if (objParam.isAddBlock) {
                const newBlock = initFormBlock();
                newBlock.block_type = ALL_BLOCK_TYPE.BLOCK_DISPLAY_1;
                newBlock.label = bodyValue;
                newBlock.is_lottery = true;
                newBlock.is_rejection = false;
                newBlock.is_scroll_none = true;
                this.initPrizeFormBlock = {
                    ...this.initPrizeFormBlock,
                    ...newBlock
                };
            } else if (objParam.isEditBlock && !this.initPrizeFormBlock.is_default_display) {
                this.initPrizeFormBlock = {
                    ...this.initPrizeFormBlock,
                    label: bodyValue
                };
            }
        },

        renderTypePrize(prizeType) {
            return TYPE_PRIZE.find((item) => item.id == prizeType)?.name ?? '';
        },

        onHandleEditPrize(prizeSerial) {
            this.isInitialPrizeData = true;
            this.configModalCreateOrEditPrize.title = this.isView ? this.$t('btn.detail') : this.$t('btn.edit');
            this.configModalCreateOrEditPrize.titleBtnSave = '';
            const clonePrize = JSON.parse(JSON.stringify(prizeSerial));
            this.formPrizeSerialInit = {
                id: clonePrize.id,
                make_id: clonePrize.make_id,
                ...initFormPrizeSerial(clonePrize)
            };
            this.formPrizeSerialConfig = configFormPrizeSerial();
            this.originProductImport = JSON.parse(JSON.stringify(clonePrize.list_product_import));
            this.onHandleAddConditionField(this.formPrizeSerialInit.prize_type);
            this.rebuildTable();
            this.configModalCreateOrEditPrize.model = true;
            this.bgrDefaultPrize = BGR_DEFAULT(this.inforForm.setting_designs.table_settings.cell_background_color);
            this.handleUpdateImage({ width: prizeSerial?.width_image, height: prizeSerial?.height_image });
            this.updateButtonEvent({ eventEditPrizeSerialCode: true });
            this.isSettingButtonLottery = false;

            this.$nextTick(() => {
                this.isInitialPrizeData = false;
            });
        },

        onHandleCopyPrize(prizeSerial) {
            if (!prizeSerial) return;
            const copyPrize = JSON.parse(JSON.stringify(prizeSerial));
            delete copyPrize.id;
            copyPrize.make_id = onHandleFakeId(this.listPrizeSerial);
            copyPrize.title = `${copyPrize.title} - ${this.$t('btn.copy')}`;
            copyPrize.probability_of_winning = 0;
            copyPrize.current_probability = 0;
            copyPrize.won_count = 0;
            copyPrize.remaining_count =
                copyPrize.prize_type === TYPE_PRIZE[1].id ? copyPrize.list_product_import?.length : Number(copyPrize.number_in_kind);
            this.handleUpdateImage({ width: copyPrize?.width_image, height: copyPrize?.height_image });
            if (copyPrize.blocks && copyPrize.blocks.length > 0) {
                copyPrize.blocks.forEach((block, index) => {
                    delete block.id;
                    block.make_id = onHandleFakeId([...copyPrize.blocks.slice(0, index)]);
                });
            }
            if (copyPrize.list_product_import && copyPrize.list_product_import.length > 0) {
                copyPrize.list_product_import.forEach((item) => {
                    delete item.id;
                    item.done = 0;
                    if (item.contents && item.contents.length > 0) {
                        item.contents.forEach((c) => delete c.id);
                    }
                });
            }
            copyPrize.prize_date_event.daily_limits = [];
            this.listPrizeSerial.push(copyPrize);
            showMessage(200, this.$bvToast, '賞品が複製されました。');
        },

        onHandleSettingCalendar(prizeSerial) {
            this.$emit('onHandleSettingCalendar', prizeSerial);
        },

        async downLoadFileCsvProd(typeDown = null) {
            let payload = {
                form_id: this.inforForm.id,
                prize_id: typeDown === 'template' ? null : this.formPrizeSerialInit.make_id
            };
            if (this.isLoadingDown) return;
            this.isLoadingDown = true;
            try {
                const dataRes = await this.downloadProductForPrize(payload);
                if (dataRes?.code !== 200) {
                    showMessage(dataRes?.code, this.$bvToast, 'Tải xuống thất bại');
                    return;
                }
                handleDownFile(dataRes?.data?.url, dataRes?.data?.file_name);
            } catch (error) {
                showMessage(error.code, this.$bvToast, error.message);
            } finally {
                this.isLoadingDown = false;
            }
        },

        onHandleChangePrizeType(typePrize) {
            this.onHandleAddConditionField(typePrize);
            this.originProductImport = [];
            this.formPrizeSerialInit.number_in_kind = '';
            this.rebuildTable();
            this.formPrizeSerialInit.blocks = (this.formPrizeSerialInit.blocks || []).filter((b) => b.is_default_display && b.is_lottery);
            this.listCheckedPrizeType = {
                is_lottery: [],
                is_rejection: []
            };
            this.$set(this.formPrizeSerialInit, 'prize_date_event', {
                daily_limits: []
            });
            this.listPrizeSerial.forEach((item) => {
                if (item?.make_id === this.formPrizeSerialInit.make_id) {
                    item.prize_date_event.daily_limits = [];
                }
            });
            this.checkAllLottery = false;
            this.checkAllRejection = false;
            this.isSettingButtonLottery = false;
        },

        onHandleAddConditionField(typePrize) {
            if (TYPE_PRIZE[0].id === typePrize) {
                this.formPrizeSerialConfig.number_in_kind.typesValidate.push('required');
            } else {
                this.formPrizeSerialConfig.number_in_kind.typesValidate = [];
            }
        },
        onHandleVisibleNumberInKind(serialPrize) {
            return serialPrize?.number_in_kind
                ? serialPrize?.number_in_kind
                : serialPrize.prize_type === TYPE_PRIZE[1].id
                  ? serialPrize?.list_product_import?.length
                  : serialPrize?.number_in_kind;
        },

        handleRemoveBlock() {
            this.updateButtonEvent({ eventSettingBlockLotterySerial: false, eventSettingBlockRejectionSerial: false });
        },

        onHandleChangeCheckedBlock(typePrize) {
            const filterBlockFollowType = this.formPrizeSerialInit.blocks?.filter((item) => item[typePrize]);
            const isAllChecked = filterBlockFollowType.length === this.listCheckedPrizeType[typePrize].length;
            switch (typePrize) {
                case 'is_lottery':
                    this.checkAllLottery = isAllChecked;
                    break;
                case 'is_rejection':
                    this.checkAllRejection = isAllChecked;
                    break;
            }
        },

        handleUpdateImage(valImage) {
            const defaultValidate = ['limit-input'];
            if (!!valImage?.id && !this.formPrizeSerialInit.extension?.aspect_ratio) {
                this.formPrizeSerialInit.extension.aspect_ratio = valImage.width / valImage.height;
            }
            this.formPrizeSerialConfig.width_image.max = this.inforForm.setting_designs.table_settings.width.table_width;
            if (valImage) {
                this.formPrizeSerialInit = {
                    ...this.formPrizeSerialInit,
                    width_image: valImage?.width || 250,
                    height_image: valImage?.height
                };
                this.formPrizeSerialConfig = {
                    ...this.formPrizeSerialConfig,
                    width_image: {
                        ...this.formPrizeSerialConfig.width_image,
                        error: false,
                        typesValidate: [...defaultValidate, 'required']
                    },
                    height_image: {
                        ...this.formPrizeSerialConfig.height_image,
                        error: false,
                        typesValidate: []
                    }
                };
            } else {
                this.formPrizeSerialConfig = {
                    ...this.formPrizeSerialConfig,
                    width_image: {
                        ...this.formPrizeSerialConfig.width_image,
                        typesValidate: defaultValidate
                    },
                    height_image: {
                        ...this.formPrizeSerialConfig.height_image,
                        typesValidate: []
                    }
                };
            }
        },

        onHandleGenerateDefaultLabel() {
            const title = this.formPrizeSerialInit.title || '賞品名';
            const imgPath = this.formPrizeSerialInit.image?.path || '';
            const width = this.formPrizeSerialInit.width_image || (imgPath ? 250 : '');
            const height = this.formPrizeSerialInit.height_image || '';

            let imgHtml = '';
            if (imgPath) {
                imgHtml = `<div style="text-align: center;"><img src="${imgPath}" style="width: ${width}px;${height ? ` height: ${height}px!important;` : ''}" /></div>`;
            } else {
                imgHtml = ``;
            }

            const titleHtml = `<div style="text-align: center; font-size: 20px; font-weight: bold;">${title}</div>`;

            return `${imgHtml}${titleHtml}`;
        },

        onHandleSyncDefaultBlock() {
            if (this.isInitialPrizeData || !this.formPrizeSerialInit.blocks) return;
            const defaultBlock = this.formPrizeSerialInit.blocks.find((b) => b.is_default_display && b.is_lottery);
            if (defaultBlock) {
                defaultBlock.label = this.onHandleGenerateDefaultLabel();
            }
        },

        handleLockRatio() {
            this.formPrizeSerialInit.extension.is_lock_ratio = !this.formPrizeSerialInit.extension.is_lock_ratio;
            if (this.formPrizeSerialInit.extension.is_lock_ratio) {
                this.handleUpdateWidthImage(this.formPrizeSerialInit.width_image);
            }
        },

        handleUpdateWidthImage(val) {
            if (!this.formPrizeSerialInit.extension.is_lock_ratio || !this.formPrizeSerialInit.extension.aspect_ratio) return;
            this.formPrizeSerialInit.height_image = Math.round(val / this.formPrizeSerialInit.extension.aspect_ratio);
        },

        handleUpdateHeightImage(val) {
            if (!this.formPrizeSerialInit.extension.is_lock_ratio || !this.formPrizeSerialInit.extension.aspect_ratio) return;
            this.formPrizeSerialInit.width_image = Math.round(val * this.formPrizeSerialInit.extension.aspect_ratio);
        }
    },

    watch: {
        dataPrizes: {
            handler(val) {
                this.listPrizeSerial = val;
            },
            immediate: true,
            deep: true
        },
        listPrizeSerial: {
            handler(val) {
                this.$emit('update:dataPrizes', val);
            },
            immediate: true,
            deep: true
        },

        'formPrizeSerialInit.title': {
            handler() {
                this.onHandleSyncDefaultBlock();
            }
        },
        'formPrizeSerialInit.image': {
            handler() {
                this.onHandleSyncDefaultBlock();
            },
            deep: true
        },
        'formPrizeSerialInit.width_image': {
            handler() {
                this.onHandleSyncDefaultBlock();
            }
        },
        'formPrizeSerialInit.height_image': {
            handler() {
                this.onHandleSyncDefaultBlock();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.alldelete {
    border-radius: 4px;
    padding: 5px 15px;
    background-color: #fff;
    border: 1px solid #707070;
    color: #000;
    &:hover {
        background-color: #ededed;
    }
}

.green02_copy {
    border-radius: 4px;
    padding: 5px 15px;
    color: #339162;
    border: solid 1px #339162;
    background-color: #fff;
    &:hover {
        opacity: 0.7;
    }
}

.text--block {
    text-align: left;
    color: #339162;
    &:hover {
        color: #70be97;
    }
}

.save__button--setting {
    background: #339162;
    border: solid 1px #339162;
    color: #ffffff;
    font-size: 13px;
    padding: 9px;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    font-weight: bold;
    width: 160px;

    &:hover {
        opacity: 0.8;
    }
}
</style>
